export const demo_SceneGraph_SolvayConference_ImageBoxes = [
  {
    id: "063e3cfd-79e0-4a7a-91f3-30e99d557b1b",
    label: "Auguste Piccard",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 114,
      y: 200.71875,
    },
    bottomRight: {
      x: 153,
      y: 245.71875,
    },
  },
  {
    id: "35224d7e-2fe8-45e4-832f-00b381b6309b",
    label: "Emile Henriot",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 172,
      y: 217.71875,
    },
    bottomRight: {
      x: 214,
      y: 264.71875,
    },
  },
  {
    id: "e835926e-c786-4038-a197-90c9d01e839b",
    label: "Paul Ehrenfest",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 219,
      y: 235.71875,
    },
    bottomRight: {
      x: 253,
      y: 278.71875,
    },
  },
  {
    id: "9ea2a660-6572-4336-aaf6-2464e484e397",
    label: "Edouard Herzen",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 280,
      y: 231.71875,
    },
    bottomRight: {
      x: 325,
      y: 276.71875,
    },
  },
  {
    id: "ebebdbc3-37bf-4329-b43b-995ee24bab32",
    label: "Theophile de Donder",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 350,
      y: 235.71875,
    },
    bottomRight: {
      x: 395,
      y: 281.71875,
    },
  },
  {
    id: "168d0144-188d-439a-9a87-dee3c688853e",
    label: "Erwin Shrodinger",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 411,
      y: 221.71875,
    },
    bottomRight: {
      x: 456,
      y: 270.71875,
    },
  },
  {
    id: "c4c993a8-c825-40a0-a820-24e5c6e02a0c",
    label: "Jules Emile Vershaffelt",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 482,
      y: 226.71875,
    },
    bottomRight: {
      x: 522,
      y: 277.71875,
    },
  },
  {
    id: "59388c90-0502-41df-917a-79a58f8ce3a3",
    label: "Wolfgang Pauli",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 547,
      y: 224.71875,
    },
    bottomRight: {
      x: 587,
      y: 268.71875,
    },
  },
  {
    id: "75567a3c-fd29-4dea-96b0-54f65a1dfc2a",
    label: "Werner Heisenberg",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 601,
      y: 220.71875,
    },
    bottomRight: {
      x: 644,
      y: 264.71875,
    },
  },
  {
    id: "468af221-f46f-4841-b462-5855ea3f99d1",
    label: "Ralph Howard Fowler",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 644,
      y: 204.71875,
    },
    bottomRight: {
      x: 685,
      y: 243.71875,
    },
  },
  {
    id: "76d07bb5-3f44-4f64-834f-a2b73a4e8696",
    label: "Leon Brillouin",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 688,
      y: 221.71875,
    },
    bottomRight: {
      x: 729,
      y: 265.71875,
    },
  },
  {
    id: "e5ecfbf1-bf73-4e79-b543-68297655c3df",
    label: "Peter Debye",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 24,
      y: 278.71875,
    },
    bottomRight: {
      x: 66,
      y: 319.71875,
    },
  },
  {
    id: "4f4130eb-3db2-40a7-9f87-1bcdcec16d28",
    label: "Martin Knudsen",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 96,
      y: 287.71875,
    },
    bottomRight: {
      x: 142,
      y: 330.71875,
    },
  },
  {
    id: "4e55696a-d200-47e7-ae93-6716abe74a24",
    label: "William Lawrence Bragg",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 178,
      y: 272.71875,
    },
    bottomRight: {
      x: 219,
      y: 319.71875,
    },
  },
  {
    id: "7d61ddbd-2caa-4cf5-8e86-497f1c983836",
    label: "Hendrik Anthony Kramers",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 261,
      y: 275.71875,
    },
    bottomRight: {
      x: 314,
      y: 323.71875,
    },
  },
  {
    id: "c7f8d501-517f-44c8-a6b9-7bb153ff6754",
    label: "Paul Dirac",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 361,
      y: 273.71875,
    },
    bottomRight: {
      x: 403,
      y: 315.71875,
    },
  },
  {
    id: "4bf93798-3f3b-4e56-8716-d0efb0458070",
    label: "Arthur Compton",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 431,
      y: 269.71875,
    },
    bottomRight: {
      x: 476,
      y: 319.71875,
    },
  },
  {
    id: "d523babf-839b-41c9-8eb3-ec613d1fdcd7",
    label: "Louis de Broglie",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 511,
      y: 282.71875,
    },
    bottomRight: {
      x: 553,
      y: 324.71875,
    },
  },
  {
    id: "2d14df29-45da-4909-89da-cc02114c0bcc",
    label: "Max Born",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 589,
      y: 278.71875,
    },
    bottomRight: {
      x: 643,
      y: 327.71875,
    },
  },
  {
    id: "7d02288f-8ceb-4e49-a60b-d45dbfe458a9",
    label: "Niels Bohr",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 672,
      y: 281.71875,
    },
    bottomRight: {
      x: 721,
      y: 331.71875,
    },
  },
  {
    id: "8f77ccc3-2047-4087-88a1-79c757f85c43",
    label: "Irving Langmuir",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 47,
      y: 301.71875,
    },
    bottomRight: {
      x: 94,
      y: 348.71875,
    },
  },
  {
    id: "073144df-0c0e-45b1-83fa-369d9149a1de",
    label: "Max Planck",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 135,
      y: 306.71875,
    },
    bottomRight: {
      x: 181,
      y: 355.71875,
    },
  },
  {
    id: "b684b301-c65e-4be3-bb59-0739a537e3d0",
    label: "Marie Sklodowska Curie",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 216,
      y: 299.71875,
    },
    bottomRight: {
      x: 262,
      y: 350.71875,
    },
  },
  {
    id: "e45db64c-bc28-4984-9735-b85b73b20e58",
    label: "Hendrik Lorentz",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 305,
      y: 309.71875,
    },
    bottomRight: {
      x: 354,
      y: 353.71875,
    },
  },
  {
    id: "87f33c8f-3d2a-4693-965c-f33b4e124c8c",
    label: "Albert Einstein",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 402,
      y: 299.71875,
    },
    bottomRight: {
      x: 461,
      y: 351.71875,
    },
  },
  {
    id: "120f792b-54d3-4459-8e73-a8dd790d4850",
    label: "Paul Langevin",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 482,
      y: 302.71875,
    },
    bottomRight: {
      x: 531,
      y: 349.71875,
    },
  },
  {
    id: "c3c57d12-18d4-4490-b95b-44ced32cbd44",
    label: "Charles Eugene Guye",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 548,
      y: 304.71875,
    },
    bottomRight: {
      x: 600,
      y: 355.71875,
    },
  },
  {
    id: "fc8562f7-5234-4589-be0e-d55257f4cc1a",
    label: "Charles Thomson Rees Wilson",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 643,
      y: 308.71875,
    },
    bottomRight: {
      x: 687,
      y: 353.71875,
    },
  },
  {
    id: "83adedae-8f80-402b-adec-0f2b2d173b3b",
    label: "Owen Wilans Richardson",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/wikipedia/Solvay_conference_1927.jpg",
    topLeft: {
      x: 704,
      y: 310.71875,
    },
    bottomRight: {
      x: 752,
      y: 361.71875,
    },
  },
];
